if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.watchId = this.dataset.watch;
        this.select = this.querySelector('.sticky-atc__size-select');
        this.button = this.querySelector('.sticky-atc__button');

        this.watchTarget = document.getElementById(this.watchId);
        if (this.watchTarget) this.observeTarget();

        if (this.button) this.button.addEventListener('click', () => this.handleClick());
      }

      observeTarget() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle('is-visible', scrolledPast);
            });
          },
          { threshold: 0 }
        );
        observer.observe(this.watchTarget);
      }

      handleClick() {
        if (this.select) {
          const option = this.select.options[this.select.selectedIndex];
          const synced = this.syncRealVariantPicker(option ? option.textContent.trim() : '');
          if (!synced) {
            const picker = document.querySelector(`#MainProduct-${this.sectionId} variant-selects, #MainProduct-${this.sectionId} .product-form__input`);
            if (picker) {
              picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
          }
        }

        const realButton = document.getElementById(this.watchId);
        if (realButton && !realButton.disabled) realButton.click();
      }

      syncRealVariantPicker(variantTitle) {
        if (!variantTitle) return true;

        const scope = document.getElementById(`MainProduct-${this.sectionId}`);
        if (!scope) return false;

        const radio = Array.from(scope.querySelectorAll('input[type="radio"][name*="options"]')).find(
          (input) => input.value.trim().toLowerCase() === variantTitle.toLowerCase()
        );
        if (radio) {
          radio.click();
          return true;
        }

        const select = Array.from(scope.querySelectorAll('select[name*="options"]')).find((sel) =>
          Array.from(sel.options).some((opt) => opt.value.trim().toLowerCase() === variantTitle.toLowerCase())
        );
        if (select) {
          const match = Array.from(select.options).find(
            (opt) => opt.value.trim().toLowerCase() === variantTitle.toLowerCase()
          );
          if (match) {
            select.value = match.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
          }
        }

        return false;
      }
    }
  );
}
